export const SET_LANGUAGE = 'SET_LANGUAGE'

export const TOGGLE_MODAL_SOON = 'TOGGLE_MODAL_SOON'

export const GET_LIST_COUNTRY = 'GET_LIST_COUNTRY'
export const GET_LIST_COUNTRY_SUCCESS = 'GET_LIST_COUNTRY_SUCCESS'
